import { SubheadBlock, TextBlock, ListBlock, Intention } from 'common/client-data-types/blocks'

export const createHeading = (text: string): SubheadBlock => ({
    kind: 'subhead',
    text,
    intentions: [],
})

export const createParagraph = (text: string, intentions?: Intention[]): TextBlock => ({
    kind: 'text',
    text,
    intentions: intentions || [],
})

export const createLinkText = (text: string, href: string): TextBlock => ({
    text,
    kind: 'text',
    intentions: [{ match: text, index: 0, href, kind: 'link' }],
})

export const createList = (
    items: TextBlock[],
    kind: 'unordered-list' | 'ordered-list'
): ListBlock => ({
    items,
    kind,
})
